import { useState } from 'react';
import s from './CodeField.module.css';
import { cx } from './cx.ts';
import t from './type.module.css';

/** Code field (S-01, proposed for the D-4 review): one square box per digit, readout digits, the
 *  box being typed in outlined in signal. One real input takes the typing, so browsers still offer
 *  the emailed code (`one-time-code`) and paste works. */
export function CodeField({
  value,
  onChange,
  length = 6,
  label,
}: {
  value: string;
  onChange: (code: string) => void;
  length?: number;
  label: string;
}) {
  const [focused, setFocused] = useState(false);
  const current = Math.min(value.length, length - 1);
  return (
    <div className={s.field}>
      <input
        className={s.input}
        aria-label={label}
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern={`\\d{${length}}`}
        maxLength={length}
        value={value}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, length))}
      />
      <div className={s.boxes} aria-hidden="true">
        {Array.from({ length }, (_, i) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: fixed positions that never reorder
            key={i}
            className={cx(s.box, t.readoutL, focused && value.length < length && i === current && s.current)}
          >
            {value[i] ?? ''}
          </span>
        ))}
      </div>
    </div>
  );
}
